<template>
  <v-col cols="12 text-center">
    <div class="font-weight-bold text-h6 justify-center">
      ¿Desea eliminar el biométrico "{{ biometrico.tipoBiometrico.title }}"?
    </div>
    <div class="justify-center pb-8 mt-4">
      <v-btn text class="mr-4" @click="CLOSE_DIALOG" :disabled="loading">Cancelar</v-btn>
      <TextButton color="red" @click="eliminar" :loading="loading" :disabled="loading">Aceptar</TextButton>
    </div>
  </v-col>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: { TextButton },
  props: {
    biometrico: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
    ...mapActions('biometrico', ['deleteBiometrico']),
    async eliminar() {
      this.loading = true
      try {
        await this.deleteBiometrico(this.biometrico.idBiometricoPersonal)
        this.$emit('updated')
        this.CLOSE_DIALOG()
      } catch {
        // El store ya muestra el mensaje de error en el snackbar.
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
